var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-container", { staticClass: "px-lg-5", attrs: { fluid: "" } }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c(
          "v-card",
          { staticClass: "rounded-card", attrs: { flat: "", outlined: "" } },
          [
            _c("v-data-table", {
              attrs: {
                headers: _vm.headers,
                items: _vm.permissions,
                "item-key": "id",
                options: _vm.options,
                "server-items-length": _vm.totalCount,
                loading: _vm.loading,
                "no-data-text": _vm.$t("messages.emptyState", {
                  entity: _vm.$tc("models.permission.entity")
                }),
                "no-results-text": _vm.$t("messages.emptyState", {
                  entity: _vm.$tc("models.permission.entity")
                })
              },
              on: {
                "update:options": [
                  function($event) {
                    _vm.options = $event
                  },
                  _vm.updateOptions
                ]
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "item.title",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "div",
                          { staticClass: "py-1" },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "availablePermissions." +
                                      _vm.availablePermissions[item.sym] +
                                      ".title"
                                  )
                                )
                              )
                            ]),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "availablePermissions." +
                                        _vm.availablePermissions[item.sym] +
                                        ".description"
                                    )
                                  ) +
                                  " "
                              )
                            ]),
                            item.enabled
                              ? _c(
                                  "app-field",
                                  _vm._b(
                                    {
                                      class: { "readonly-chips": !_vm.isAdmin },
                                      on: {
                                        input: function($event) {
                                          return _vm.bindData(
                                            $event,
                                            item.field
                                          )
                                        }
                                      }
                                    },
                                    "app-field",
                                    item.field,
                                    false
                                  )
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "item.enabled",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("v-simple-checkbox", {
                          attrs: { disabled: !_vm.isAdmin },
                          model: {
                            value: item.enabled,
                            callback: function($$v) {
                              _vm.$set(item, "enabled", $$v)
                            },
                            expression: "item.enabled"
                          }
                        })
                      ]
                    }
                  }
                ],
                null,
                true
              )
            }),
            _vm.isAdmin
              ? _c(
                  "v-btn",
                  {
                    staticClass: "pull-right my-3",
                    attrs: { depressed: "", color: "primary" },
                    on: { click: _vm.submit }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("actions.save")) + " ")]
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }